import { LogoIcon } from "components/Icons";

import styles from "./MainSidebar.module.scss";

export const MainSidebarSkeleton = () => {
  return (
    <div
      className={styles.root}
      data-testid="sidebar-skeleton"
    >
      <div className={styles.sidebarHead}>
        <div className={styles.logo}>
          <LogoIcon />
        </div>
      </div>
      <div className={styles.sidebarFooter} />
    </div>
  );
};
